import '../styles/ComingMatches.css';
import '../styles/App.css';
import Match from './Match.jsx';

// Component for coming matches -section

const ComingMatches = ({ matches, setMatchData, loading }) => {

    const comingMatchesEmpty = matches.filter( (match) => new Date(match.matchInfo.eventDate) > new Date(Date.now())).length === 0

    return(
        <div className="coming-matches">
            <h2>TULEVAT OTTELUT</h2>

            <p>Saat näkyviin hankkimasi liput painamalla nuolta ottelutietojen vierestä.</p>

            <p 
                style={{
                    display: comingMatchesEmpty ? 'inline-block' : 'none',
                    alignItems: 'center',
                    fontSize: '17px',
                    fontFamily: 'Finlandica-Regular',
                    color: '#FFFFFF',
                    borderRadius: '10px',
                    backgroundColor: '#A99B70',
                    margin: '1vw 5vw 5vw 5vw',
                    padding: '15px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
            >
                {loading
                    ? 'Ladataan...'
                    : 'Ei lippuja tuleviin otteluihin'
                }
            </p>

            <div className="matches-list">
                {(matches || [])
                        .filter( (match) => new Date(match.matchInfo.eventDate) > new Date(Date.now()))
                        .sort((a, b) => new Date(a.matchInfo.eventDate) - new Date(b.matchInfo.eventDate))
                        .map((match) => (
                            <Match
                                key={match.eventId}
                                matchId={match.eventId}
                                matchInfo={match.matchInfo}
                                tickets={match.tickets}
                                setMatchData={setMatchData}
                            />
                    ))}
            </div>

        </div>
    )
};

export default ComingMatches;